import styled from "@emotion/styled";
import { Button } from "../../../button";

// a faux-medium-button.
export const DatePickerFooterButton = styled(Button)`
    height: 32px;
    min-width: 96px;
    font-weight: 600;
`;
